import { Fragment } from "react";
import { textClasses } from "../../styles/texts";

const RenderText = ({ style, classes, children }) => {
    const textClass = textClasses();
    classes = classes.reduce((cls, c) => cls + " " + textClass[c], "");

    return (
        <div className={classes} style={style}>
            {children}
        </div>
    );
}

export const Text = ({ style, classes = [], children }) => (
    <Fragment>
        <RenderText {...{ style, classes, children }} />
    </Fragment>
);